import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DisabledIcon from '@mui/icons-material/HideSource';
import { WorkMode } from '../SessionTree/SessionTree.types';
import { useStyles, EditSessionButton } from './EditButton.styles';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';

interface EditButtonProps {
  workMode: WorkMode;
  isDisabled?: boolean;
  handleEditMode: () => void;
  isExamDetails?: boolean;
}

const EditButton: React.FC<EditButtonProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      {props.workMode === WorkMode.EDIT && props.isExamDetails ? null : (
        <TooltipOneComponent
          title={props.workMode === WorkMode.ADD || props.isDisabled ? 'Nie można edytować tego elementu' : ''}
          placement="top"
        >
          <span>
            <EditSessionButton
              disableRipple
              className={classes.editButton}
              variant="contained"
              disabled={props.workMode === WorkMode.ADD || props.isDisabled}
              startIcon={
                !props.isDisabled ? (
                  <EditIcon className={classes.editButtonIcon} />
                ) : (
                  <DisabledIcon className={classes.disableButtonIcon} />
                )
              }
              onClick={props.handleEditMode}
            >
              Edytuj
            </EditSessionButton>
          </span>
        </TooltipOneComponent>
      )}
    </>
  );
};

export default EditButton;
